import { combineSlices, configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import allParameterSlice from './Slice/AllParameter';
import authSlice from './Slice/AuthSlice';
import authCreateAccountSlice from './Slice/CreateAccountSlice';
import authDialogConfigSlice from './Slice/DialogSlice';
import { StammdatenAPI } from './api/StammdatenAPI';

const authReducers = combineSlices(
    authSlice
    , authDialogConfigSlice
    , authCreateAccountSlice
);

export const store = configureStore({
    reducer: {
        authSlice: authReducers,
        authReducer: authReducers,

        allParameter: allParameterSlice.reducer,
        [StammdatenAPI.reducerPath]: StammdatenAPI.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false
        }).concat(
            StammdatenAPI.middleware
        )
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;